"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DadosSku = void 0;
var DadosSku = /** @class */ (function () {
    function DadosSku(_a) {
        var _b = _a._id, _id = _b === void 0 ? { m: '', d: '', e: '', c: '', g: '' } : _b, _c = _a.material, material = _c === void 0 ? '' : _c, _d = _a.descricao, descricao = _d === void 0 ? '' : _d, _e = _a.grade, grade = _e === void 0 ? '' : _e, _f = _a.data, data = _f === void 0 ? '' : _f, _g = _a.dataMatch, dataMatch = _g === void 0 ? new Date() : _g, _h = _a.estacao, estacao = _h === void 0 ? '' : _h, _j = _a.colecao, colecao = _j === void 0 ? '' : _j, _k = _a.qtdVenda, qtdVenda = _k === void 0 ? 0 : _k, _l = _a.qtdPrevisao, qtdPrevisao = _l === void 0 ? 0 : _l, _m = _a.qtdSegundaQualidade, qtdSegundaQualidade = _m === void 0 ? 0 : _m, _o = _a.loteMinimo, loteMinimo = _o === void 0 ? 0 : _o, _p = _a.qtdEstoqueLote, qtdEstoqueLote = _p === void 0 ? 0 : _p, _q = _a.qtdEstoqueProducao, qtdEstoqueProducao = _q === void 0 ? 0 : _q, _r = _a.qtdEstoquePlanejada, qtdEstoquePlanejada = _r === void 0 ? 0 : _r, _s = _a.qtdEstoquePlanejadaFix, qtdEstoquePlanejadaFix = _s === void 0 ? 0 : _s, _t = _a.qtdEstoquePedido, qtdEstoquePedido = _t === void 0 ? 0 : _t, _u = _a.qtdEstoqueRequisicao, qtdEstoqueRequisicao = _u === void 0 ? 0 : _u, _v = _a.qtdWipNordeste, qtdWipNordeste = _v === void 0 ? 0 : _v, _w = _a.qtdAlocada, qtdAlocada = _w === void 0 ? 0 : _w, _x = _a.multiplo, multiplo = _x === void 0 ? '' : _x, _y = _a.fatorRisco, fatorRisco = _y === void 0 ? {} : _y, _z = _a.regraEstoque, regraEstoque = _z === void 0 ? new Array() : _z, _0 = _a.estoqueMinMax, estoqueMinMax = _0 === void 0 ? {
            _id: { material: '', grade: '', dataRem: '' },
            DATA_REM: '',
            MATERIAL: '',
            GRADE: '',
            ESTQ_SEG: 0,
            CHAVE_COMP: { material: '', grade: '', dataRem: '' },
        } : _0, _1 = _a.conjunto, conjunto = _1 === void 0 ? '' : _1, _2 = _a.folhas, folhas = _2 === void 0 ? {} : _2, _3 = _a.umb, umb = _3 === void 0 ? '' : _3, _4 = _a.qtdProgramada, qtdProgramada = _4 === void 0 ? 0 : _4, _5 = _a.chaveFilhoConj, chaveFilhoConj = _5 === void 0 ? { m: '', d: '', e: '', c: '', g: '' } : _5, _6 = _a.conjuntoComp, conjuntoComp = _6 === void 0 ? new Array() : _6, _7 = _a.conjuntoFilho, conjuntoFilho = _7 === void 0 ? false : _7, _8 = _a.conjuntoFilhoTipo, conjuntoFilhoTipo = _8 === void 0 ? '' : _8;
        this._id = _id;
        this.material = material;
        this.descricao = descricao;
        this.grade = grade;
        this.data = data;
        this.dataMatch = dataMatch;
        this.estacao = estacao;
        this.colecao = colecao;
        this.qtdVenda = qtdVenda;
        this.qtdPrevisao = qtdPrevisao;
        this.qtdSegundaQualidade = qtdSegundaQualidade;
        this.loteMinimo = loteMinimo;
        this.qtdEstoqueLote = qtdEstoqueLote;
        this.qtdEstoqueProducao = qtdEstoqueProducao;
        this.qtdEstoquePlanejada = qtdEstoquePlanejada;
        this.qtdEstoquePlanejadaFix = qtdEstoquePlanejadaFix;
        this.qtdEstoquePedido = qtdEstoquePedido;
        this.qtdEstoqueRequisicao = qtdEstoqueRequisicao;
        this.qtdWipNordeste = qtdWipNordeste;
        this.qtdAlocada = qtdAlocada;
        this.multiplo = multiplo;
        this.fatorRisco = fatorRisco;
        this.regraEstoque = regraEstoque;
        this.estoqueMinMax = estoqueMinMax;
        this.conjunto = conjunto;
        this.folhas = folhas;
        this.umb = umb;
        this.qtdProgramada = qtdProgramada;
        this.chaveFilhoConj = chaveFilhoConj;
        this.conjuntoComp = conjuntoComp;
        this.conjuntoFilho = conjuntoFilho;
        this.conjuntoFilhoTipo = conjuntoFilhoTipo;
    }
    return DadosSku;
}());
exports.DadosSku = DadosSku;
//# sourceMappingURL=DadosSku.js.map